module.exports = __webpack_public_path__ + "static/img/img_cat_28.42ad1e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_cat_28.png
// module id = 547
// module chunks = 1